import { CHARGE_POINT_ROUTES } from 'shared/consts/routes/charge-point';
import { MenuAddButton } from 'shared/ui/section-menu';

export function AddChargePointsGroupMenuButtonLink() {
  return (
    <MenuAddButton
      label="Добавить группу"
      path={CHARGE_POINT_ROUTES.ADD_CHARGE_POINT_GROUP}
      requiredRights={[
        {
          controller: 'Group',
          right: 'Write',
        },
      ]}
    />
  );
}
